import { Button, Stack, Typography } from "@mui/material";

export default function RewardClaim({ points }) {
    return (
        <Stack gap={1} alignItems="center">
            <Button variant="contained" href="mailto:sav@learnylib.com" disabled={points < 1}>
                Réclamer ma récompense
            </Button>
            {points > 0 &&
                <Typography variant="body2" color="text.secondary">sav@learnylib.com</Typography>
            }
        </Stack>
    );
}